
TPS.EditProfile = {
    memberProfile: {},
    formParentSelector: null,
    flyoutSelector: '#member-flyout',
    errorBlockSelector: '#error-callout',
    successBlockSelector: '#success-callout',
    type: "",
    init: function (formWrapper) {
        TPS.EditProfile.formParentSelector = formWrapper;

        if (TPS.EditProfile.formParentSelector) {
            TPS.Forms.setupClientValidation(TPS.EditProfile.formParentSelector); // .generate-pin-form

            //Load Webservices
            TPS.Util.loadWebserviceJS('CMSApp.AV.API.Membership');
            TPS.EditProfile.loadProfile(TPS.EditProfile.formParentSelector, false);
        }
    },
    newCustomer: function (formWrapper) {
        TPS.EditProfile.formParentSelector = formWrapper;
        if (TPS.EditProfile.formParentSelector) {
            TPS.Forms.setupClientValidation(TPS.EditProfile.formParentSelector); // .generate-pin-form

            //Load Webservices
            TPS.Util.loadWebserviceJS('CMSApp.AV.API.Membership');
            TPS.EditProfile.loadProfileNewCustomer(TPS.EditProfile.formParentSelector, false);
        }
    },
    registration: function (formWrapper) {
        TPS.EditProfile.formParentSelector = formWrapper;
        if (TPS.EditProfile.formParentSelector) {
            TPS.Forms.setupClientValidation(TPS.EditProfile.formParentSelector); // .generate-pin-form

            //Load Webservices
            TPS.Util.loadWebserviceJS('CMSApp.AV.API.Membership');
            TPS.EditProfile.loadProfileRegistration(TPS.EditProfile.formParentSelector, false);
        }
    },
    loadProfile: function (f, onLoad) {
        CMSApp.AV.API.Membership.MyProfile(function (d) {
            TPS.EditProfile.type = 1;
            TPS.EditProfile.storeProfile(d);
            TPS.EditProfile.populateProfile(f);

        }, TPS.Util.displayError);
    },
    loadProfileNewCustomer: function (f, onLoad) {
        CMSApp.AV.API.Membership.ProfileNewCustomer(function (d) {
            TPS.EditProfile.type = 2;
            TPS.EditProfile.storeProfile(d);
            TPS.EditProfile.populateProfile(f);

        }, TPS.Util.displayError);
    },
    loadProfileRegistration: function (f, onLoad) {
        CMSApp.AV.API.Membership.MyProfile(function (d) {
            TPS.EditProfile.type = 3;
            TPS.EditProfile.storeProfile(d);
            TPS.EditProfile.populateProfile(f);

        }, TPS.Util.displayError);
    },
    storeProfile: function (d) {
        if (d.Object.Company != null)
            TPS.EditProfile.memberProfile.partnerCompany = d.Object.Company.Name;
        TPS.EditProfile.memberProfile.AvailableRelationships = d.Object.AvailableRelationships;
        TPS.EditProfile.memberProfile.AvailableVehicles = d.Object.AvailableVehicles;
        TPS.EditProfile.memberProfile.Firstname = d.Object.Firstname;
        TPS.EditProfile.memberProfile.Lastname = d.Object.Lastname;
        TPS.EditProfile.memberProfile.Email = d.Object.Email;
        TPS.EditProfile.memberProfile.MobilePhone = d.Object.MobilePhone;
        TPS.EditProfile.memberProfile.Phone = d.Object.Phone;
        TPS.EditProfile.memberProfile.Address = d.Object.Address;
        TPS.EditProfile.memberProfile.City = d.Object.City;
        TPS.EditProfile.memberProfile.ZipCode = d.Object.ZipCode;
        TPS.EditProfile.memberProfile.State = d.Object.State;
        TPS.EditProfile.memberProfile.Country = d.Object.Country;
        TPS.EditProfile.memberProfile.optIn = d.Object.OptIn;
        TPS.EditProfile.memberProfile.preferredContactMethod = d.Object.ContactMethod;
        TPS.EditProfile.memberProfile.preferredCultureCode = d.Object.PreferredCulture;

    },
    populateProfile: function (f) {
        var _f = f;
        f = jQuery(f);

        if (TPS.EditProfile.memberProfile.Email.includes("@volvocars.com"))
            CMSApp.AV.API.Membership.GetVolvoPartners(TPS.EditProfile.memberProfile.preferredCultureCode, function (d) {
                TPS.Util.populateDropdown('#partnerCompany', d, true, "");
                jQuery('#partnerCompany').prepend("<option value='' selected='selected'>Please select</option>");
                jQuery('#partnerCompany').removeAttr("disabled");
            });
        else
            CMSApp.AV.API.Membership.GetDealers(TPS.EditProfile.memberProfile.preferredCultureCode, function (d) {
                TPS.Util.populateDropdown('#partnerCompany', d, true, "");
                jQuery('#partnerCompany').prepend("<option value='' selected='selected'>Please select</option>");
                jQuery('#partnerCompany').removeAttr("disabled");
            });

        jQuery('#partnerCompany', f).val(TPS.EditProfile.memberProfile.partnerCompany);
        jQuery('#firstname', f).val(TPS.EditProfile.memberProfile.Firstname);
        jQuery('#lastname', f).val(TPS.EditProfile.memberProfile.Lastname);

        jQuery('#phoneNumberMobile', f).val(TPS.EditProfile.memberProfile.MobilePhone);
        jQuery('#phoneNumber', f).val(TPS.EditProfile.memberProfile.Phone);
        jQuery('#emailAddress', f).val(TPS.EditProfile.memberProfile.Email);

        if (TPS.EditProfile.memberProfile.Address != null) {
            jQuery('#address', f).val(TPS.EditProfile.memberProfile.Address.Address);
            jQuery('#city', f).val(TPS.EditProfile.memberProfile.Address.City);
            jQuery('#zipcode', f).val(TPS.EditProfile.memberProfile.Address.ZipCode);
            jQuery('#state', f).val(TPS.EditProfile.memberProfile.Address.State);
            jQuery('#country', f).val(TPS.EditProfile.memberProfile.Address.Country);
        }

        jQuery('#preferredContactMethod', f).children(":input").each(function () {
            var input = jQuery(this);

            if (input.attr('value') == TPS.EditProfile.memberProfile.preferredContactMethod)
                input.prop('checked', true);
        });

        if (TPS.EditProfile.memberProfile.optIn) {
            jQuery('#optIn', f).prop('checked', true);
        } else {
            jQuery('#optIn', f).prop('checked', false);
        }

        if (TPS.EditProfile.memberProfile.Address == null)
            TPS.Util.initCountryStateDropDown(_f + ' #country', _f + ' #state', "", "");
        else
            TPS.Util.initCountryStateDropDown(_f + ' #country', _f + ' #state', TPS.EditProfile.memberProfile.Address.Country, TPS.EditProfile.memberProfile.Address.State);

        TPS.EditProfile.ProfileListeners();

    },
    updateFlyout: function () {

        var flyOut = jQuery(TPS.EditProfile.flyoutSelector);

        var address = '<br/>' + TPS.EditProfile.memberProfile.Address.Address;
        address += '<br/>' + TPS.EditProfile.memberProfile.Address.City;
        address += ', ' + TPS.EditProfile.memberProfile.Address.State;
        address += '<br/>' + TPS.EditProfile.memberProfile.Address.ZipCode;

        flyOut.find('.name-wrapper').empty().text(TPS.EditProfile.memberProfile.Firstname + ' ' + TPS.EditProfile.memberProfile.Lastname);
        flyOut.find('.address-wrapper').empty().html(address);
        flyOut.find('.tel-wrapper').empty().text(TPS.EditProfile.memberProfile.Phone);
        flyOut.find('.email-wrapper-link').empty().text(TPS.EditProfile.memberProfile.Email).attr('href', 'mailto:' + TPS.EditProfile.memberProfile.Email);

    },
    ProfileListeners: function () {
        TPS.EditProfile.submitForm()
    },
    submitForm: function () {

        jQuery(TPS.EditProfile.formParentSelector).find('.submit-form').on('click', function (e) {
            e.preventDefault();

            var button = jQuery(this);

            TPS.Forms.resetMessageBlock(TPS.EditProfile.errorBlockSelector + ', ' + TPS.EditProfile.successBlockSelector);

            if (TPS.Forms.validator.checkForm() && !button.hasClass('submitting')) {

                button.addClass('submitting').append(TPS.Util.submitSpinner);

                var vals = TPS.Forms.getFormVals(TPS.EditProfile.formParentSelector);

                if (TPS.EditProfile.type == 2)
                    CMSApp.AV.API.Membership.SaveMyCustomerProfile(
                        vals.partnerCompany,
                        vals.firstname,
                        vals.lastname,
                        vals.emailAddress,
                        vals.address,
                        vals.city,
                        vals.state,
                        vals.zipcode,
                        vals.phoneNumber,
                        vals.phoneNumberMobile,
                        vals.optIn,
                        vals.preferredContactMethod,
                        success,
                        fail
                    );
                else if (TPS.EditProfile.type == 3)
                    CMSApp.AV.API.Membership.SaveRegister(
                        vals.address,
                        vals.city,
                        vals.state,
                        vals.zipcode,
                        vals.phoneNumber,
                        vals.phoneNumberMobile,
                        vals.optIn,
                        vals.preferredContactMethod,
                        vals.password,
                        vals.confirmPassword,
                        success,
                        fail
                    );
                else
                    CMSApp.AV.API.Membership.SaveMyProfile(
                        vals.address,
                        vals.city,
                        vals.state,
                        vals.zipcode,
                        vals.phoneNumber,
                        vals.phoneNumberMobile,
                        vals.optIn,
                        vals.preferredContactMethod,
                        success,
                        fail
                    );

                function success(data) {
                    if (data.Success) {
                        TPS.EditProfile.storeProfile(data);
                        TPS.EditProfile.updateFlyout();
                        TPS.Forms.scrollToMessages(window.labels.success, true, TPS.EditProfile.successBlockSelector, '.hidden-magellan-success', true);
                        if (TPS.EditProfile.type == 2 || TPS.EditProfile.type == 3) {
                            setTimeout(function () { window.location.href = '/' }, 3000);
                        }
                    } else {
                        TPS.Forms.scrollToMessages(data.ErrorMessages, true, TPS.EditProfile.errorBlockSelector, '.hidden-magellan-error', false);
                    }
                    button.find('.icon').remove();
                    button.removeClass('submitting');
                }

                function fail(data) {
                    TPS.Forms.scrollToMessages(data._statusCode + " : " + data._message, true, TPS.EditProfile.errorBlockSelector, '.hidden-magellan-error', true);
                    button.find('.icon').remove();
                    button.removeClass('submitting');
                }


            } else {

                console.log(TPS.Forms.validator.numberOfInvalids() + ' validation errors');
            }

        });

    }

}
